"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalTicketWorkflowTransport = exports.WorkflowTaskTransport = exports.WorkflowTaskLabels = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("./enums");
const tag_1 = require("./tag");
const visibility_1 = require("./visibility");
exports.WorkflowTaskLabels = typebox_1.Type.Object({
    title: typebox_1.Type.String(),
    subtitle: typebox_1.Type.Array(typebox_1.Type.Object({
        label: typebox_1.Type.String(),
        value: typebox_1.Type.String(),
    })),
});
exports.WorkflowTaskTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    note: typebox_1.Type.String(),
    entityID: typebox_1.Type.String(),
    entityType: typebox_1.Type.Union([enums_1.WaysteInternalTicketRelatedEntity, enums_1.SourgumInternalTicketRelatedEntity]),
    priority: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: -2, maximum: 2 })),
    labels: typebox_1.Type.Optional(exports.WorkflowTaskLabels),
    tags: typebox_1.Type.Array(tag_1.TagTransport),
    images: typebox_1.Type.Array(common_1.S3ItemReference),
    status: typebox_1.Type.Optional(enums_1.InternalTicketStatus),
    assignedToProfileID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    replyToID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    dueDate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' }))),
    isPinned: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    visibility: typebox_1.Type.Array(visibility_1.VisibilityTransport),
    followerIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    assignedTeam: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
});
exports.InternalTicketWorkflowTransport = typebox_1.Type.Object({
    OPEN: typebox_1.Type.Object({
        results: typebox_1.Type.Array(exports.WorkflowTaskTransport),
        totalCount: typebox_1.Type.Number(),
    }),
    IN_PROGRESS: typebox_1.Type.Object({
        results: typebox_1.Type.Array(exports.WorkflowTaskTransport),
        totalCount: typebox_1.Type.Number(),
    }),
    SOLVED: typebox_1.Type.Object({
        results: typebox_1.Type.Array(exports.WorkflowTaskTransport),
        totalCount: typebox_1.Type.Number(),
    }),
});
//# sourceMappingURL=workflow-task.js.map